import { Fragment } from 'react';

import { currencyFormat } from 'common/helpers/numberHelper';

const GiftCards = (props) => {
  const { tenders, settings } = props;
  return tenders.map((tender) => {
    if (
      tender.tenderType === 'Gift Card' &&
      tender.amountTendered > 0 &&
      tender.chargeStatus !== 'Failed'
    ) {
      return (
        <Fragment key={tender.id}>
          Gift Card: {tender.giftCard.maskedCode}
          <br />
          Amount: {currencyFormat(tender.amountTendered, settings)}
          <br />
          <br />
        </Fragment>
      );
    }
    return null;
  });
};

export default GiftCards;
